export const IMG_W = 8192;
export const IMG_H = 6656;

// Convert bottom-left Y to top-left Y (image pixels)
export function blToTopLeftY(yBL: number) {
  return IMG_H - yBL;
}

// Normalized top-left coordinates
export function toUVTL(xTL: number, yTL: number) {
  return { uTL: xTL / IMG_W, vTL: yTL / IMG_H };
}

export function fromUVTL(uTL: number, vTL: number) {
  return { xTL: uTL * IMG_W, yTL: vTL * IMG_H };
}

// Map normalized [0..1] to pseudo lon/lat for Supercluster usage
// We keep it linear for simplicity: lng ∈ [-180,180], lat ∈ [85,-85]
export function uvToLngLat(uTL: number, vTL: number) {
  const lng = uTL * 360 - 180;
  const lat = 85 - vTL * 170;
  return { lng, lat };
}

export function lngLatToUv(lng: number, lat: number) {
  const uTL = (lng + 180) / 360;
  const vTL = (85 - lat) / 170;
  return { uTL, vTL };
}

// Map between OSD zoom and supercluster integer zoom
export function clusterZoomFromViewer(item: OpenSeadragon.TiledImage, viewer: OpenSeadragon.Viewer) {
  const viewportZoom = viewer.viewport.getZoom(true);
  const imageZoom = item.viewportToImageZoom(viewportZoom);
  const pixelsAcross = IMG_W * imageZoom;
  const z = Math.log2(pixelsAcross / 512);
  return Math.max(0, Math.min(16, Math.round(z)));
}

export function viewerZoomFromCluster(item: OpenSeadragon.TiledImage, viewer: OpenSeadragon.Viewer, clusterZ: number) {
  const imageZoom = Math.pow(2, clusterZ) * 512 / IMG_W;
  const viewportZoom = item.imageToViewportZoom(imageZoom);
  return viewportZoom;
}

